<ng-container *ngIf="this.ownCommunityMemberList$ | async as ownCommunityMemberList">
  <div class="dialog" mat-dialog-content>
    <div *ngIf="!(ownCommunityMemberList.length > 0)" class="message-container">
      <img class="empamos-icon" src="../../../assets/files/empamos_logo_molecule.png" alt="image" width="45px" height="45px"><div class="header">Bist du Teil der EMPAMOS-Community?</div>
      <br/>
      <mat-divider></mat-divider>
      <div class="message-text">
        Um dein Design mit anderen Community-Mitgliedern teilen zu können, musst du selbst Mitglied in der EMPAMOS-Community sein. Leider konnten wir dich in unserem Community-System nicht finden. Dies kann an zwei Ursachen liegen:
        <ul>
          <li><strong>Du hast noch keinen Account in unserem Community-System?</strong> <br/>Registriere dich als Mitglied in unserem <a href="https://community.empamos.de">Community-System</a>. Wichtig: Nutze für die Registrierung dieselbe E-Mail-Adresse, mit der du dich auch in der WebApp registriert hast.</li>
          <li style="padding-top:10px;"><strong>Du verwendest im Community-System eine andere Mailadresse?</strong> <br/>Ändere deine Mailadresse im Community-System auf dieselbe Adresse, mit der du dich für die WebApp registriert hast.</li>
        </ul>
        Falls keiner der beiden Punkte zutrifft, schreib uns unter <a href="mailto:info@empamos.de">info&#64;empamos.de</a>.
      </div>
    </div>
    <ng-container *ngIf="(ownCommunityMemberList.length > 0)">
      <ng-container *ngIf="this.messageSent !== undefined" class="card-content-container">
        <div *ngIf="this.messageSent !== null && this.messageSent.id !== null" class="message-container">
          <div class="material-symbols-outlined message-icon">check_circle</div>
          <div class="info-text">
            Die Einladung wurde erfolgreich versendet. Du kannst sie im Community-System unter diesem Link als gesendete Nachrichten aufrufen: <a target="_blank" href="{{this.COMMUNITY_URL + this.messageSent.post_url}}">{{this.COMMUNITY_URL + this.messageSent.post_url}}</a>
          </div>
        </div>
        <div *ngIf=" this.messageSent === null || this.messageSent.id === null" class="message-container">
          <div class="material-symbols-outlined message-icon">error</div>
          <div class="info-text">
            Die Einladung konnte aufgrund eines technischen Fehlers nicht über das Community-System verschickt werden. Versuch es später noch einmal. Sollte es dann immer noch nicht klappen, dann schreib uns unter <a href="mailto:info@empamos.de">info&#64;empamos.de</a>.
          </div>
        </div>
      </ng-container>
      <mat-tab-group *ngIf="this.messageSent === undefined" dynamicHeight class="tab-group" [(selectedIndex)]="this.selectedTab" (selectedTabChange)="onTabChange($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">person_add</mat-icon>
            &nbsp;&nbsp;Einladen
          </ng-template>
          <form [formGroup]="shareForm">
            <div class="card-content-container">
              <div class="card-content">
                <div class="visualization_container">
                  <em-card-visualization *ngIf="sharedDesign.positionings.length > 0" [positionings]="sharedDesign.positionings"></em-card-visualization>
                </div>
                <div class="design_title_description_container description_box">
                  <mat-card-header class="design_title">
                    <mat-card-title>{{ this.decodeDesignName(sharedDesign.name) }}</mat-card-title>
                    <mat-card-subtitle>{{ sharedDesign.lastModifiedDateTime | date:"short":'':'de-De'}}</mat-card-subtitle>
                  </mat-card-header>
                  <mat-card-content class="design_description">
                    <p class="description_text">
                      {{
                      sharedDesign.description
                      }}
                    </p>
                  </mat-card-content>
                </div>
              </div>
              <div class="card-content">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Community-Mitglied</mat-label>
                  <input type="text"
                         maxlength="30"
                         matInput
                         required
                         emAutoFocus
                         name="username"
                         formControlName="username"
                         [formControl]="username"
                         [matAutocomplete]="auto">
                  <mat-autocomplete #auto="matAutocomplete">
                    @for (option of filteredOptions | async; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                  </mat-autocomplete>
                  <mat-hint *ngIf="this.isValid || !this.username.value">Mit wem möchtest du dein Design teilen?</mat-hint>
                  <mat-hint class="errorMessage" *ngIf="!this.isValid && this.username.value">Kein Community Mitglied gefunden</mat-hint>
                </mat-form-field>
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Private Nachricht</mat-label>
                  <textarea  style="resize: none"
                             name="message"
                             formControlName="message"
                             [formControl]="message"
                             matInput rows="5" cols="40"
                             [maxLength]="500">
                  </textarea>
                  <mat-hint>Möchtest du eine Nachricht hinzufügen?</mat-hint>
                </mat-form-field>
              </div>
            </div>
            <br/>
            <div>
              <mat-radio-group [formControl]="shareOptions" class="radio-group" aria-label="Select an option">
                <div class="radio-button">
                  <mat-radio-button class="radio-button" value="view" [checked]="true">
                  <span class="material-symbols-outlined radio-icon">visibility</span>
                  <span class="radio-header">Anschauen</span><br/>
                  <span class="radio-text">Andere können dein Design nur sehen. </span>
                  </mat-radio-button>
                </div>
                <div class="radio-button">
                  <mat-radio-button class="radio-button" value="edit">
                  <span class="material-symbols-outlined radio-icon">edit_square</span>
                  <span class="radio-header">Mitarbeiten</span><br/>
                  <span class="radio-text">Andere dürfen dein Design verändern.</span>
                  </mat-radio-button>
                </div>
              </mat-radio-group>
            </div>
          </form>
        </mat-tab>
        <mat-tab [disabled]="this.dataSource.data.length === 0" matSort>
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">group</mat-icon>
            &nbsp;&nbsp;Verwalten
          </ng-template>
          <table *ngIf="this.dataSource.data.length > 0" mat-table [dataSource]="dataSource" class="mat-elevation-z8 share-table">
            <!-- createdDateTime Column -->
            <ng-container matColumnDef="createdDateTime">
              <th mat-header-cell *matHeaderCellDef mat-sort-header><span class="material-symbols-outlined radio-icon">mail</span>Einladung</th>
              <td mat-cell *matCellDef="let designInvitation"><a target="_blank" href="{{this.getCommunityMessageUrl(designInvitation.postUrl)}}">{{designInvitation.createdDateTime | date:"short":'':'de-De'}}</a> </td>
            </ng-container>

            <!-- receiverUserName Column -->
            <ng-container matColumnDef="receiverUsername">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> <span class="material-symbols-outlined radio-icon">person</span>Empfänger</th>
              <td mat-cell *matCellDef="let designInvitation"> <a target="_blank" href="{{this.getCommunityMemberUrl(this.designInvitation.receiverUsername)}}">{{designInvitation.receiverUsername}}</a> </td>
            </ng-container>

            <!-- shareOption Column -->
            <ng-container matColumnDef="shareOption">
              <th class="shareOption-column" mat-header-cell *matHeaderCellDef mat-sort-header> <span class="material-symbols-outlined radio-icon" matTooltip="Berechtigung">lock</span></th>
              <td mat-cell *matCellDef="let designInvitation">
                <ng-container *ngIf="designInvitation.shareOption === 'view'">
                  <span class="material-symbols-outlined radio-icon" matTooltip="Anschauen">visibility</span>
                </ng-container>
                <ng-container *ngIf="designInvitation.shareOption === 'edit'">
                  <span class="material-symbols-outlined radio-icon" matTooltip="Mitarbeiten">edit_square</span>
                </ng-container>
              </td>
            </ng-container>

            <!-- postUrl Column -->
            <ng-container matColumnDef="accepted">
              <th class="accepted-column" mat-header-cell *matHeaderCellDef mat-sort-header><span class="material-symbols-outlined radio-icon" matTooltip="Status">question_exchange</span></th>
              <td mat-cell *matCellDef="let designInvitation">
                <ng-container *ngIf="designInvitation.accepted">
                  <span class="material-symbols-outlined radio-icon" matTooltip="Akzeptiert">check_circle</span>
                </ng-container>
                <ng-container *ngIf="!designInvitation.accepted">
                  <span class="material-symbols-outlined radio-icon"  matTooltip="Noch nicht akzeptiert">pending</span>
                </ng-container>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th class="action-column" mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let designInvitation">
                <button type="button" mat-button="elevated" (click)="this.deleteInvitation(designInvitation)">
                  <span class="material-symbols-outlined radio-icon">delete_forever</span>Löschen
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator *ngIf="this.dataSource.data.length > 5" [pageSize]="5"
                         aria-label="Select page">
          </mat-paginator>
          <div class="message-text" *ngIf="this.dataSource.data.length === 0">Es gibt keine offenen Einladungen mehr zu deinem Design.</div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-actions class="actions">
    <button type="button" mat-button color="primary" mat-dialog-close>Schließen</button>
    <button  *ngIf="this.messageSent === undefined && ownCommunityMemberList.length > 0 && this.isOnSharingTab" [disabled]="!this.isValid || this.ownCommunityMemberList[0].username === this.username.value" type="submit"  mat-raised-button color="accent" (click)="shareDesign(ownCommunityMemberList[0])">Einladen</button>
    <button  *ngIf="this.messageSent !== undefined && this.messageSent.id !== null" type="button"  mat-raised-button color="accent" (click)="shareAgain()">Weiter einladen</button>
  </div>
</ng-container>
